function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDellLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007db8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-8.01 0-15.264-3.249-20.516-8.505a28.896 28.896 0 0 1-8.501-20.516 28.89 28.89 0 0 1 8.501-20.507C-15.264-54.777-8.01-58.032 0-58.032c8.012 0 15.27 3.255 20.514 8.504a28.89 28.89 0 0 1 8.492 20.507c0 8.014-3.24 15.272-8.492 20.516A28.89 28.89 0 0 1 0 0m0 3.516c17.965 0 32.531-14.568 32.531-32.537C32.531-46.984 17.965-61.55 0-61.55c-17.963 0-32.535 14.566-32.535 32.529C-32.535-11.052-17.963 3.516 0 3.516",
    transform: "matrix(4.57996 0 0 -4.57996 150.01 17.103)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007db8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0 1.896-1.258 2.973-3.039 2.973h-1.09v-5.948h1.059C-1.414-2.975 0-2.075 0 0m19.389-2.14-8.03-6.323L4.02-2.685C2.961-5.229.402-6.996-2.545-6.996h-6.281V6.996h6.281c3.293 0 5.666-2.094 6.563-4.325l7.341 5.772 2.719-2.14L7.35 1.015 8.643.003l6.726 5.285 2.723-2.134-6.727-5.294 1.291-1.014 6.733 5.295v4.855h4.881v-9.908h4.869v-4.101h-9.75v4.873zm15.933-.774h4.867v-4.099h-9.753V6.996h4.886v-9.91z",
    transform: "matrix(4.57996 0 0 -4.57996 79.539 148.804)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDellLogo);
export default __webpack_public_path__ + "static/media/dell-logo.fd0ef76aa42604ae31ba2e93e6b1ec2c.svg";
export { ForwardRef as ReactComponent };